import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import {
  resourcesReports,
  resourcesBranch,
  resourcesBranchGeo,
} from "../../../helpers/backend_helper";
import { getStorageUser } from "../../../helpers/api_helper";
import { Container, Input, Label } from "reactstrap";
import PreviewPDF from "../../../helpers/previewPDF";
import Select from "react-select";
import PeriodFilterHelper from "../../../helpers/PeriodFilterHelper";
import { useParams } from "react-router-dom";
import ButtonHelper from "../../../helpers/ButtonHelper";
import dayjs from "dayjs";

const startTime = dayjs().startOf("day").format("HH:mm");
const endTime = dayjs().endOf("day").format("HH:mm");

const QuemadosReport = () => {
  let timeElapsed = dayjs();
  let dateNow = `${timeElapsed.format("YYYY-MM-DD")}`;
  const { report } = useParams();
  const [columnas, setColumnas] = useState();
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [ramales, setRamales] = useState([]);
  const [ramal, setRamal] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: authUser.company_id,
    initDate: dateNow,
    endDate: dateNow,
    ramal_id: null,
    startTime,
    endTime,
  });
  const filtersOperators = { select: true };
  const [items, setItems] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    let params = { params: filters };
    if (filters.ramal_id) {
      setPending(true);
      resourcesReports(
        "show",
        params,
        `quemadas${report == "unidades" ? "Unidad" : "Operador"}Report`
      ).then((response) => {
        const items = [...response.data.data]
        setItems(items);
        setColumnas(response.columns);
        console.log(response);
        let meta = {
          current_page: response.data.current_page,
          from: response.data.from,
          last_page: response.data.last_page,
          links: response.data.links,
          path: response.data.path,
          per_page: response.data.per_page,
          to: response.data.to,
          total: response.data.total,
        };
        setDataPag(meta);

        setPending(false);
      });
    }
  }, [filters, report]);
  useEffect(() => {
    let params = { params: filtersOperators };

    resourcesBranch("get", params).then((response) => {
      setRamales(response.data);
    });
  }, []);

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };

    resourcesReports(
      "show",
      config,
      `quemadas${report == "unidades" ? "Unidad" : "Operador"}Report`
    ).then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ReporteQuemadas.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModal({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  const columns = Columns(columnas, filters, ramal, report);
  document.title = "Quemadas|Reportes";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle={`Quemadas ${
                report == "unidades" ? "Unidades" : "Operadores"
              }`}
              columns={columns}
              items={items}
              filterInp={false}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <ButtonHelper
                addButon={false}
                reportButons={true}
                actionReportButon={getReports}
              />

              <PeriodFilterHelper
                setFilters={setFilters}
                filters={filters}
                getReports={getReports}
                modal={modal}
                setModal={setModal}
              />
              <div className="col-sm-2">
                <Label className="form-label">Tiempo inicial</Label>
                <Input
                  className="form-control"
                  type="time"
                  value={filters.startTime}
                  onChange={(e) => {
                    const { value: startTime } = e.target;
                    if (!startTime) return;

                    setFilters((prev) => ({
                      ...prev,
                      startTime,
                    }));
                  }}
                />
              </div>
              <div className="col-sm-2">
                <Label className="form-label">Tiempo final</Label>
                <Input
                  className="form-control"
                  type="time"
                  value={filters.endTime}
                  onChange={(e) => {
                    const { value: endTime } = e.target;
                    if (!endTime) return;

                    setFilters((prev) => ({
                      ...prev,
                      endTime,
                    }));
                  }}
                />
              </div>
              <div className="col-sm-2">
                <label className="form-label">Ramal:</label>
                <Select
                  style={{ padding: "01.25rem 0.5rem" }}
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  defaultValue={ramal}
                  isSearchable={false}
                  name="week"
                  placeholder="Ramal"
                  options={ramales}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => [
                    setRamal(e),
                    setFilters({ ...filters, ramal_id: e ? e.id : null }),
                  ]}
                />
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && <PreviewPDF modalPdf={modal} setModalPdf={setModal} />}
      </div>
    </React.Fragment>
  );
};

export default QuemadosReport;
